import Selector from 'components/ui/Selector'

interface AutoCoverSelectorProps {
  value?: number
  update: (value: number) => void
  disabled?: boolean
}

const AUTO_COVER_OPTIONS = [
  {
    code: 0,
    name: 'No HD Cover',
  },
  {
    code: 1,
    name: 'HD Cover',
  },
  {
    code: 2,
    name: 'HD Cover + BGColor',
  },
]

export const AutoCoverSelector = ({ 
  value, 
  update,
  disabled = false 
}: AutoCoverSelectorProps) => {
  return (
    <Selector
      datas={AUTO_COVER_OPTIONS}
      update={update}
      value={value}
      labelName="Cover"
      placeholder={"Select a Cover"}
    />
  )
}
